module.exports = __webpack_public_path__ + "img/Windows_Explorer_Icon.5ccccaac.svg";